<template>
  <div class="seal" v-if="detailObj">
    <div class="title-wrap">
      <div class="title-info">
        <div class="title">
          <div class="main-title">{{ detailObj.flowInfo.procTitle }}</div>
          <!-- <div class="sub-title">{{ detailObj.flowInfo.procName }}</div> -->
        </div>
        <div class="status">({{ detailObj.flowInfo.flowStatus }})</div>
      </div>
      <div class="other-info">
        <div class="no">
          <span class="label">单据号：</span>
          <span class="value"> {{ detailObj.flowInfo.projectCode }}</span>
        </div>
        <div class="time">{{ detailObj.flowInfo.startTime }}</div>
      </div>
    </div>
    <Accordion title="项目信息" :iconColorType="-2">
      <div class="detail-row row-m_t">
        <div class="row-label">流程名称</div>
        <div class="row-value">{{ detailObj.flowInfo.procName }}</div>
      </div>
      <div class="detail-row">
        <div class="row-label">任务优先度</div>
        <div class="row-value">{{ detailObj.flowInfo.priority }}</div>
      </div>
      <div class="detail-row">
        <div class="row-label">期望办理日期</div>
        <div class="row-value">{{ detailObj.flowInfo.exprctDate }}</div>
      </div>
      <div class="detail-row">
        <div class="row-label">项目描述</div>
        <div class="row-value">{{ detailObj.flowInfo.procjectInfo }}</div>
      </div>
    </Accordion>
    <div
      v-for="(groupValue, groupKey, index) in detailObj.factorList"
      :key="index"
    >
      <template v-if="groupKey === '基本信息'">
        <Accordion :title="groupKey" :iconColorType="index">
          <div
            :class="['detail-row', { 'row-m_t': key === 0 }]"
            v-for="(item, key) in groupValue"
            :key="key"
          >
            <div class="row-label">{{ item.factorname }}</div>
            <div class="row-value">{{ item.factordefval }}</div>
          </div>
        </Accordion>
      </template>
      <template v-else>
        <Accordion :title="groupKey" :iconColorType="index">
          <div
            :class="['detail-row', { 'row-m_t': key === 0 }]"
            v-for="(item, key) in groupValue"
            :key="'i' + key"
          >
            <div class="row-label">{{ item.factorname }}</div>
            <div class="row-value">{{ item.factordefval }}</div>
          </div>
        </Accordion>
      </template>
    </div>
    <template v-if="detailObj.textList">
      <div
        v-for="(groupValue, groupKey, index) in detailObj.textList"
        :key="'g' + index"
      >
        <Accordion
          :title="groupKey"
          :iconColorType="
            index +
              (Object.getOwnPropertyNames(detailObj.factorList).length - 1)
          "
        >
          <template v-for="(item, key) in groupValue">
            <div
              :class="[
                'detail-title-wrap',
                { 'border-none': key === groupValue.length - 1 }
              ]"
            >
              <div class="detail-name" @click="openItem(item)">
                {{ item.textname }}
              </div>
            </div>
          </template>
        </Accordion>
      </div>
    </template>

    <Accordion title="流转记录" :iconColorType="-2">
      <div class="timeline-wrap">
        <a-timeline
          v-if="detailObj.approvalList && detailObj.approvalList.length > 0"
        >
          <a-timeline-item
            v-for="(item, index) in detailObj.approvalList"
            :key="'c' + index"
          >
            <div
              slot="dot"
              class="defout-timeline-icon"
              v-if="item.approvetime"
            ></div>
            <a-icon
              slot="dot"
              type="clock-circle"
              style="font-size: 16px;color:#1FC5E8"
              v-else
            />
            <div class="timeline-row">
              <span class="name">{{ item.approveusername || '' }}</span>
              <span
                >{{ item.exitactionname || '' }}
                {{ item.approvetime || '' }}</span
              >
            </div>
            <div class="timeline-row">
              <span class="sub-txt sub-left">{{ item.remark || '' }}</span>
              <span class="sub-txt sub-right">{{
                item.processnodeid || ''
              }}</span>
            </div>
          </a-timeline-item>
        </a-timeline>
        <span v-else>暂无流转记录信息</span>
      </div>
    </Accordion>

    <SubmitMessage v-if="showSubmitMessage" ref="SubmitMessage" />
    <div class="btn-group" v-if="detailObj.btnList.length">
      <div
        class="btn"
        v-for="item in detailObj.btnList"
        @click="btnClick(item.factorcode)"
      >
        {{ item.factorname }}
      </div>
    </div>
    <SelectApprovalUser
      ref="SelectApprovalUser"
      :approvalUsersTree="approvalUsersTree"
      @onEnsure="ensureClick"
    />
  </div>
</template>
<script>
import Accordion from '@/components/Accordion/index'
import SubmitMessage from '@/components/SubmitMessage/index'
import SelectApprovalUser from '@/components/SelectApprovalUser/index'
import { btnsFilter } from '../tools/common'
export default {
  name: 'SealPage',
  data() {
    return {
      detailObj: null,
      activeKey: 'base',
      actionValueObj: null,
      approvalUsersType: 'notice', // 获取下个节点的type
      approvalUsersTree: null,
      factorcode: '' // 当前点击按钮id notice coordinate submit processBack doneRead
    }
  },
  computed: {
    showSubmitMessage() {
      return (
        this.detailObj.btnList.findIndex(
          item =>
            ['submit', 'processBack', 'doneRead'].indexOf(item.factorcode) > -1
        ) > -1
      )
    }
  },
  components: {
    Accordion,
    SubmitMessage,
    SelectApprovalUser
  },
  beforeMount() {
    this.getDetailMessageAndActionValue()
  },
  methods: {
    openItem(obj) {
      console.log(obj)
      const param = JSON.parse(obj.param)
      console.log(param)
      crh.openOAFileFromEMAP({
        param: param
      })
    },
    async getDetailMessageAndActionValue() {
      console.log(this.user)
      console.log(this.run)
      console.log(this.device)
      try {
        const queryObj = this.$route.query
        if (!queryObj.processInstanceId) {
          throw new Error('路径不完整')
        }
        let resDetail = await this.$request.post({
          // api: 'crass.amcs.hrzc.processDetail',
          api: `${process.env.VUE_APP_apiBaseCode}.processDetail`,
          version: '1.0',
          params: {
            processInstanceId: queryObj.processInstanceId, // 路径获取
            hsBpmKey: queryObj.hsBpmKey, // 路径获取
            starter: queryObj.starter, // 路径获取
            bizFlag: queryObj.bizFlag, // 路径获取
            curAssigneeName: queryObj.curAssigneeName, // 路径获取
            hsBpmInstanceId: queryObj.hsBpmInstanceId, // 路径获取
            querymode: queryObj.querymode, // 路径获取
            otype: queryObj.otype, // 路径获取
            userId: this.user.userId,
            uid: this.user.userId,
            appCode: this.run.appCode,
            userToken: this.user.userToken
          }
        })
        const resdata = resDetail.RETURN_DATA.data
        resdata.btnList = btnsFilter(resdata.btnList)
        //操作基础信息在第一位置
        if (
          resdata.factorList &&
          resdata.factorList.hasOwnProperty('基本信息')
        ) {
          const baseInfo = { 基本信息: resdata.factorList['基本信息'] }
          resdata.factorList = { ...baseInfo, ...resdata.factorList }
        }
        this.detailObj = resdata

        let resAction = await this.$request.post({
          // api: 'crass.amcs.hrzc.getActionValue',
          api: `${process.env.VUE_APP_apiBaseCode}.getActionValue`,
          version: '1.0',
          params: {
            taskId: this.detailObj.taskId,
            otype: 'runMobile',
            userId: this.user.userId,
            uid: this.user.userId,
            appCode: this.run.appCode,
            userToken: this.user.userToken
          }
        })
        this.actionValueObj = resAction.RETURN_DATA.data
      } catch (error) {
        console.log(error.message)
        this.$modal.error({
          title: '温馨提示',
          content: error.message || '未知错误，请联系管理员'
        })
      }
    },
    btnClick(factorcode) {
      const openDrawer = key => {
        // 判断点击是哪个按钮, 是否点击了不同按钮
        if (this.factorcode !== factorcode) {
          this.approvalUsersTree = null // 清空树组件选择情况
          // 清空组件对象内操作数据
          this.$refs['SelectApprovalUser'].resetData()
        }
        // 赋值点击按钮类型
        this.factorcode = factorcode
        // 打开抽屉组件
        this.$refs['SelectApprovalUser'].openDrawer()
        // 获取操作审批人 点击另外的按钮
        if (!this.approvalUsersTree) {
          this.$nextTick(() => {
            this.findNextApprovalUser(key)
          })
        }
      }
      if (['notice', 'coordinate'].indexOf(factorcode) > -1) {
        openDrawer('notice')
      } else if (factorcode === 'submit') {
        // 校验必填
        if (!this.$refs.SubmitMessage.getValue()) {
          this.$message.warning({
            duration: 5,
            content: '处理意见必填'
          })
          return
        }
        // 获取操作审批人的入参type, 公章用印/发起人是自己的提交，需要选择下一个审批人，否则直接点击提交
        const queryObj = this.$route.query
        if (
          queryObj.hsBpmKey === 'othersealnew' &&
          queryObj.bizFlag === 'tobeProcess' &&
          queryObj.starter === this.user.userId
        ) {
          this.approvalUsersType = 'next'
          openDrawer('next')
        } else {
          this.saveProcess()
        }
      } else if (factorcode === 'processBack') {
        // 校验必填
        if (!this.$refs.SubmitMessage.getValue()) {
          this.$message.warning({
            duration: 5,
            content: '处理意见必填'
          })
          return
        }
        // alert('驳回还在开发中')
        this.processBack()
      } else if (factorcode === 'doneRead') {
        // 校验必填
        if (!this.$refs.SubmitMessage.getValue()) {
          this.$message.warning({
            duration: 5,
            content: '处理意见必填'
          })
          return
        }
        this.doneRead()
      }
    },
    async findNextApprovalUser(approvalUsersType) {
      try {
        const queryObj = this.$route.query
        let resApprovalUsers = await this.$request.post({
          // api: 'crass.amcs.hrzc.findNextApprovalUser',
          api: `${process.env.VUE_APP_apiBaseCode}.findNextApprovalUser`,
          version: '1.0',
          params: {
            taskId: this.detailObj.taskId,
            processInstanceId: queryObj.processInstanceId,
            type: approvalUsersType,
            hsBpmKey: queryObj.hsBpmKey,
            btnIndex: 1, // 固定
            actionValue: this.actionValueObj['workflow.actionValue'],
            version: this.actionValueObj.version,
            nodeName: this.actionValueObj.nodeName,
            uid: this.user.userId,
            appCode: this.run.appCode,
            userToken: this.user.userToken,
            otype: 'runMobile'
          }
        })
        let approvalUsersTree = resApprovalUsers.RETURN_DATA.data
        // 后台数据问题，格式化一下
        approvalUsersTree[0].userList = JSON.parse(
          approvalUsersTree[0].userList
        )
        console.log('1', approvalUsersTree)
        this.approvalUsersTree = approvalUsersTree
      } catch (error) {
        this.$modal.error({
          title: '温馨提示',
          content: error.message || '未知错误，请联系管理员'
        })
      }
    },
    // 选节点子组件点击提交
    ensureClick(leafItems) {
      // 携带参数发起接口请求
      switch (this.factorcode) {
        case 'notice': // 知会
          this.coordinateAndNotice('notice', leafItems)
          break
        case 'coordinate': // 会签
          this.coordinateAndNotice('coordinate', leafItems)
          break
        case 'submit': // 提交
          const leafIds = leafItems.map(item => item.code)
          console.log(leafIds)
          this.saveProcess(leafIds)
          break
      }
    },
    /**
     * 驳回
     */
    async processBack() {
      try {
        const queryObj = this.$route.query
        const params = {
          'FlowVariables.projectcode': this.detailObj.flowInfo.projectCode,
          savebtn: '驳回发起人',
          hsBpmRemark: this.$refs.SubmitMessage.getValue(),
          WorkflowAttachfiles: '',
          'workflow.processKey': queryObj.hsBpmKey,
          'workflow.instanceId': queryObj.processInstanceId,
          'workflow.taskId': this.detailObj.taskId,
          hsBpmActionName: '驳回发起人',
          _WorkflowFieldsArrayString:
            '["FlowVariables.projectcode","hsBpmRemark","workflow.processKey","workflow.processVersion","workflow.instanceId","workflow.taskId","workflow.taskType","workflow.activityName","workflow.actionValue","savebtn","hsBpmName","busiJumpaddress","companyCode","hsBpmFlowInfo.bizFlowUuid","hsBpmActionName"]',
          userId: this.user.userId,
          'workflow.activityName': this.actionValueObj.nodeName,
          'workflow.actionValue': this.actionValueObj['workflow.backValue'],
          uid: this.user.userId,
          appCode: this.run.appCode,
          userToken: this.user.userToken,
          otype: 'runMobile'
        }
        console.log(params)
        let resProcessBack = await this.$request.post({
          // api: 'crass.amcs.hrzc.saveProcess',
          api: `${process.env.VUE_APP_apiBaseCode}.saveProcess`,
          version: '1.0',
          params
        })
        let returnCode = resProcessBack.RETURN_DATA.code
        if (returnCode === 200) {
          let content = resProcessBack.RETURN_DATA.data
          const nextDealNameIndex = content.indexOf('currentInfo=')
          content.slice(nextDealNameIndex + 12, -1)
          this.$modal.success({
            title: '流程已驳回',
            content: '下个节点人：' + content.slice(nextDealNameIndex + 12, -1),
            onOk() {
              crh.closeWebApp()
            }
          })
        } else {
          throw new Error('驳回失败！')
        }
      } catch (error) {
        console.log(error.message)
        this.$modal.error({
          title: '温馨提示',
          content: error.message || '未知错误，请联系管理员'
        })
      }
    },
    /**
     * 提交
     */
    async saveProcess(leafIds) {
      try {
        const queryObj = this.$route.query
        let params = {
          'FlowVariables.projectcode': this.detailObj.flowInfo.projectCode,
          savebtn: '提交',
          hsBpmRemark: this.$refs.SubmitMessage.getValue(),
          WorkflowAttachfiles: '',
          'workflow.processKey': queryObj.hsBpmKey,
          'workflow.instanceId': queryObj.processInstanceId,
          'workflow.taskId': this.detailObj.taskId,
          hsBpmActionName: '提交',
          _WorkflowFieldsArrayString:
            '["FlowVariables.projectcode","hsBpmRemark","workflow.processKey","workflow.processVersion","workflow.instanceId","workflow.taskId","workflow.taskType","workflow.activityName","workflow.actionValue","savebtn","hsBpmName","busiJumpaddress","companyCode","isShowPrintPreviewPage","hsBpmFlowInfo.bizFlowUuid","hsBpmActionName","flowRelation.bindInstanceIDS","isRejectWorkflow"]',
          userId: this.user.userId,
          'workflow.activityName': this.actionValueObj.nodeName,
          'workflow.actionValue': this.actionValueObj['workflow.actionValue'],
          uid: this.user.userId,
          appCode: this.run.appCode,
          userToken: this.user.userToken,
          otype: 'runMobile'
        }
        // 如果有选择下一个节点，说明是公章用印的第一次提交，有些额外的参数要传
        if (leafIds) {
          // 搞不懂的后台判断
          let _WorkflowFieldsArrayString = `["FlowVariables.projectcode","hsBpmRemark","workflow.processKey","workflow.processVersion","workflow.instanceId","workflow.taskId","workflow.taskType","workflow.activityName","workflow.actionValue","savebtn","hsBpmName","busiJumpaddress","companyCode","isShowPrintPreviewPage","hsBpmFlowInfo.bizFlowUuid","hsBpmActionName","flowRelation.bindInstanceIDS","isRejectWorkflow"${
            this.approvalUsersType === 'notice'
              ? ''
              : ',"bpm_candidate_项目组组长","bpm_seq_candidate_curr_项目组组长"'
          }]`
          console.log(_WorkflowFieldsArrayString)
          params = Object.assign(params, {
            _WorkflowFieldsArrayString,
            bpm_candidate_项目组组长: leafIds.toString(),
            bpm_seq_candidate_curr_项目组组长: leafIds.toString()
          })
        }
        console.log(params)
        let resSaveProcess = await this.$request.post({
          // api: 'crass.amcs.hrzc.saveProcess',
          api: `${process.env.VUE_APP_apiBaseCode}.saveProcess`,
          version: '1.0',
          params
        })
        let returnCode = resSaveProcess.RETURN_DATA.code
        if (returnCode === 200) {
          let content = resSaveProcess.RETURN_DATA.data
          const nextDealNameIndex = content.indexOf('currentInfo=')
          content.slice(nextDealNameIndex + 12, -1)
          this.$modal.success({
            title: '流程已提交',
            content: '下个节点人：' + content.slice(nextDealNameIndex + 12, -1),
            onOk() {
              crh.closeWebApp()
            }
          })
        } else {
          throw new Error(resSaveProcess.RETURN_DATA.data)
        }
      } catch (error) {
        console.log(error.message)
        this.$modal.error({
          title: '温馨提示',
          content: error.message || '未知错误，请联系管理员'
        })
      }
    },
    /**
     * 知会/会签
     */
    async coordinateAndNotice(operationKey, leafItems) {
      try {
        const queryObj = this.$route.query
        const params = {
          users: leafItems,
          taskId: this.detailObj.taskId,
          processNodeId:
            this.actionValueObj.nodeName +
            (operationKey === 'notice' ? '【交阅意见】' : '【交办意见】'),
          param1: this.detailObj.flowInfo.procTitle,
          processInstanceId: queryObj.processInstanceId,
          remark: '知会',
          msgCode: 'MSG_JOINTLY_SIGN',
          bizFlag: operationKey,
          savebtn: operationKey === 'notice' ? '知会' : '会签',
          uid: this.user.userId,
          appCode: this.run.appCode,
          userToken: this.user.userToken,
          otype: 'runMobile'
        }
        let resAoordinateAndNotice = await this.$request.post({
          // api: 'crass.amcs.hrzc.coordinateAndNotice',
          api: `${process.env.VUE_APP_apiBaseCode}.coordinateAndNotice`,
          version: '1.0',
          params
        })
        let returnCode = resAoordinateAndNotice.RETURN_DATA.code
        if (returnCode === 200) {
          this.$message.success({
            duration: 5,
            content: (operationKey === 'notice' ? '知会' : '会签') + '成功！'
          })
        } else {
          throw new Error(
            (operationKey === 'notice' ? '知会' : '会签') + '失败！'
          )
        }
      } catch (error) {
        console.log(error.message)
        this.$modal.error({
          title: '温馨提示',
          content: error.message || '未知错误，请联系管理员'
        })
      }
    },
    /**
     * 已阅
     */
    async doneRead() {
      try {
        const queryObj = this.$route.query
        const params = {
          users: [{ taskId: this.detailObj.taskId, userId: this.user.userId }],
          taskId: this.detailObj.taskId,
          processInstanceId: queryObj.processInstanceId,
          hasReadBtnName: '已阅',
          hsBpmKey: queryObj.hsBpmKey,
          processNodeId: this.actionValueObj.nodeName,
          noticeMsg: this.$refs.SubmitMessage.getValue(),
          uid: this.user.userId,
          appCode: this.run.appCode,
          userToken: this.user.userToken,
          otype: 'runMobile'
        }
        console.log(params)
        let resDoneRead = await this.$request.post({
          // api: 'crass.amcs.hrzc.doneRead',
          api: `${process.env.VUE_APP_apiBaseCode}.doneRead`,
          version: '1.0',
          params
        })
        let returnCode = resDoneRead.RETURN_DATA.code
        if (returnCode === 200) {
          this.$modal.success({
            title: '温馨提示',
            content: '已阅成功！',
            onOk() {
              crh.closeWebApp()
            }
          })
        } else {
          throw new Error('已阅失败！')
        }
      } catch (error) {
        console.log(error.message)
        this.$modal.error({
          title: '温馨提示',
          content: error.message || '未知错误，请联系管理员'
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '../style/var';
.seal {
  min-height: 100vh;
  -webkit-overflow-scrolling: touch;
  /deep/ .ant-timeline-item-last > .ant-timeline-item-tail {
    display: block;
  }
}
.timeline-wrap {
  padding: 20px 0 10px;
  .defout-timeline-icon {
    width: 14px;
    height: 14px;
    border-radius: 10px;
    border: 2px solid #e8e8e8;
  }
  .timeline-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;
    font-size: 12px;
    .name {
      font-size: 15px;
    }
    .sub-txt.sub-left {
      margin-right: 15px;
      text-align: left;
    }
    .sub-txt.sub-right {
      display: flex;
      justify-content: flex-end;
      text-align: justify;
    }
    .sub-txt {
      margin-top: 5px;
      color: #666;
      flex: 1;
    }
  }
}
.title-wrap {
  padding: 15px 10px 10px;
  border-bottom: 1px solid #f2f2f2;
  .title-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      flex: 1;
      .main-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
      }
      .sub-title {
        font-size: 14px;
        line-height: 1.2;
        color: #333;
      }
    }
    .status {
      // width: 76px;
      font-size: 14px;
      text-align: right;
      color: #ffb403;
    }
  }
  .other-info {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
    font-size: 12px;
    color: #666;
    .label {
      color: #aaa;
      font-weight: normal;
    }
  }
}
.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 20px;
  color: #666;
  .row-label {
    color: #aaa;
    width: 100px;
  }
  .row-value {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    text-align: justify;
  }
}
.row-m_t {
  margin-top: 20px;
}
.detail-title-wrap {
  margin: 10px 0;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
  font-size: 15px;
  .detail-name {
    color: #333;
    flex: 1;
  }
}
.detail-title-wrap.border-none {
  border-bottom: 0;
  margin-bottom: 0;
}
.btn-group {
  display: flex;
  margin: 15px 10px 20px;
  border-radius: 5px;
  overflow: hidden;
  // border: 1px solid #aaa;
  & .btn {
    flex: 1;
    padding: 8px 0;
    text-align: center;
    border-right: 1px solid #fff;
    background: #ffb403;
    color: #fff;
    &:active {
      background-color: #ccc;
      font-weight: bold;
    }
    &:last-child {
      border-right: none;
    }
  }
}
.base-info {
  margin-bottom: 7rem;
}
.file-card {
  border: 1px solid #ccc;
}
</style>
